import { featureFlagClient } from '@trello/feature-flag-client';
import {
  OrganizationFeature,
  OrganizationFeatures,
} from '@trello/product-features';
import { dontUpsell } from '@trello/config';

export function hasAdvancedChecklists(orgProductNumber?: number) {
  return (
    !!orgProductNumber &&
    OrganizationFeatures.isFeatureEnabled(
      OrganizationFeature.AdvancedChecklists,
      orgProductNumber,
    )
  );
}

export function hasUpsell(canEdit: boolean, canSeeTeam: boolean) {
  return (
    canEdit &&
    canSeeTeam &&
    featureFlagClient.get('remarkable.advanced-checklist-upsell', false) &&
    !dontUpsell
  );
}

export function shouldShowEditModeButtons(
  orgProductNumber: number | undefined = undefined,
  canEdit: boolean = false,
  canSeeTeam: boolean = false,
) {
  return (
    hasUpsell(canEdit, canSeeTeam) || hasAdvancedChecklists(orgProductNumber)
  );
}
